export const skillGroups = [
  {
    id: 'languages',
    label: 'Languages',
    description: 'Core programming and scripting languages',
    items: ['Python', 'C#', 'JavaScript', 'TypeScript', 'SQL', 'HTML5 / CSS3', 'Java', 'C++', 'Go', 'Rust', 'R']
  },
  {
    id: 'ai-ml',
    label: 'AI & Machine Learning',
    description: 'Deep learning, statistical modeling, and agent systems',
    items: ['PyTorch', 'TensorFlow', 'XGBoost', 'Scikit-learn', 'Pandas', 'NumPy', 'NLP', 'AI Agent Architectures', 'RAG Systems', 'Model Context Protocol (MCP)']
  },
  {
    id: 'frameworks',
    label: 'Frameworks & Web',
    description: 'Modern full-stack and API development frameworks',
    items: ['FastAPI', 'React', 'Angular', 'ASP.NET Core', 'Django', 'Flask', 'Node.js', 'Tailwind CSS']
  },
  {
    id: 'architecture',
    label: 'Architecture & Systems',
    description: 'Distributed systems, security, and performance patterns',
    items: [
      'RESTful API Design',
      'Auth & Security (JWT, OAuth 2.0)',
      'Async & Concurrent Programming',
      'Caching Strategies (LRU, Redis, TTL)',
      'Rate Limiting & Throttling',
      'Microservices Architecture',
      'Database Indexing & Query Tuning',
      'Design Patterns & Clean Code',
      'Dependency Injection'
    ]
  },
  {
    id: 'databases',
    label: 'Databases & Storage',
    description: 'Relational, NoSQL, and memory stores',
    items: ['PostgreSQL', 'SQLite', 'MongoDB', 'Redis', 'Entity Framework']
  },
  {
    id: 'devops-tools',
    label: 'DevOps & Tooling',
    description: 'Build, deployment, and version management tools',
    items: ['Git / GitHub', 'Docker', 'CI/CD GitHub Actions', 'Linux / Bash', 'Postman', 'PowerBI', 'Tableau']
  },
  {
    id: 'certifications',
    label: 'Industry Certifications',
    description: 'Cloud provider and architecture credentials',
    items: [
      'AWS Solutions Architect – Associate',
      'AWS Certified Cloud Practitioner',
      'Google Associate Cloud Engineer',
      'Microsoft Azure Fundamentals (AZ-900)'
    ]
  }
];
